import React from "react"
import type { RouteObject } from "react-router-dom"

import { RoutesPaths } from "../../../../constants/routes.ts"
import CheckEmailCode from "../../../CheckEmailCode"
import ConfirmChangeEmailPage from "../../../ConfirmChangeEmailPage"
import LoginPage from "../../../LoginPage/LoginPage.tsx"
import NewPasswordPage from "../../../NewPasswordPage.tsx"
import RestorePasswordPage from "../../../RestorePasswordPage"
import SignUpPage from "../../../SignUpPage"
import StartupPage from "../../../StartupPage"
import VerifyCodePage from "../../../VerifyCodePage"
import WhatsAppLoginPage from "../../../WhatsApp/WhatsAppLoginPage/WhatsAppLoginPage.tsx"

// Auth routes (public)
export const authRoutes: RouteObject[] = [
  {
    index: true,
    element: <StartupPage />
  },
  {
    path: "login",
    element: <LoginPage />
  },
  {
    path: "login/:hash",
    element: <LoginPage />
  },
  {
    path: RoutesPaths.auth.whatsapp_login,
    element: <WhatsAppLoginPage />
  },
  {
    path: "confirm-email-change/:token",
    element: <ConfirmChangeEmailPage />
  },
  {
    path: "sign-up",
    element: <SignUpPage />
  },
  {
    path: "add-email",
    element: <SignUpPage />
  },
  {
    path: "sign-up/confirm/:hash",
    element: <CheckEmailCode />
  },
  {
    path: "restore-password",
    element: <RestorePasswordPage />
  },
  {
    path: "verify-code",
    element: <VerifyCodePage />
  },
  {
    path: "restore-password/:hash",
    element: <NewPasswordPage />
  }
]
